import * as React from 'react';
import Popover from '@mui/material/Popover';
import { AspectRatio, BorderAll, BorderBottom, BorderClear, BorderLeft, BorderOuter, BorderRight, BorderTop, Check, Collections, Image, Link, NavigateBefore, OneKPlus, UploadFile } from '@mui/icons-material';
import { Alert, Button, ButtonGroup, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, Menu, Slider, Snackbar, Stack, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { toHaveStyle } from '@testing-library/jest-dom/matchers';
import Service from '../../../util/Service';
import GaleriaComp from '../../util/GaleriaComp';
import ImagemSizeComp from './ImagemSizeComp';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

export default function ImagemPopover(props) {
    const { onSelect, image, refDiv, refreshEditor } = props;
    const [clonedContent, setClonedContent] = React.useState(null);
    const [linkImg, setLinkImg] = React.useState(false);
    const [nomeArquivo, setNomeArquivo] = React.useState('');
    const [tipoAnexo, setTipoAnexo] = React.useState('');
    const [erroTipo, setErroTipo] = React.useState('');
    const [descricaoAnexo, setDescricaoAnexo] = React.useState('');

    const [openSnack, setOpenSnack] = React.useState(false);
    const [isShowGaleria, setIsShowGaleria] = React.useState(false);

    const [openUpload, setOpenUpload] = React.useState(false);
    const [borderStyle, setBorderStyle] = React.useState('solid');
    const [dashSize, setDashSize] = React.useState(1);
    const [msg, setMsg] = React.useState();

    const [anchorElBorder, setAnchorElBorder] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const openBorder = Boolean(anchorElBorder);

    const id = open ? 'imagem-popover' : undefined;

    React.useEffect(() => {
        if (open) {
            // img.src = 'https://www.w3schools.com/css/img_lights.jpg'; 
            const s = window.getSelection();
            if (s.rangeCount === 0) {
                handleClose();
                setOpenSnack(true);
                return;
            }
            console.log(s);
            console.log(s.rangeCount);
            const range = s.getRangeAt(0);//s.baseNode;
            const cc = range.startContainer;//.cloneContents(); //extractContents();            
            setClonedContent(cc);
        }
    }, [open]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        setTimeout(() => {
            setOpenUpload(false);
            setLinkImg(false);
            setIsShowGaleria(false);
        }, 300);
    };
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setMsg();
        setOpenSnack(false);
    };
    const handleOpenBorda = (e) => {
        setAnchorElBorder(e.currentTarget);
    }
    const handleCloseBorder = () => {
        setAnchorElBorder(null);
    };
    function handleSubmetLink() {
        const val = document.getElementById('link-imagem')
        console.log(val.value);
        createImg(val.value)
        setLinkImg(false);
        handleClose();
    }

    const handleChangeborderStyle = (event, nextView) => {
        console.log(nextView);
        setBorderStyle(nextView);
    };

    const handleChangeDashSize = (event, newValue) => {
        setDashSize(newValue);
    };
    function handleBorda(b) {
        
        if (b === 'all') {
            image.style.border = dashSize + "px " + borderStyle + " black";
        } else {
            console.error('Não implementado')
        }

        console.log(image.style)

        handleClose();
        handleCloseBorder();
    }

    const upload = () => {
        let input = document.getElementById("file");
        const file = input.files;
        if (file) {
            console.log(file[0]);
            if (!file[0]) {
                console.log('>>entrou no metodo sair<<')
                setTimeout(() => {
                    console.log('>>sair<<')
                    setOpenUpload(false);
                }, 3000);

                return;
            }
            const fileReader = new FileReader();
            const preview = document.getElementById('file-preview');
            fileReader.onload = event => {
                preview.setAttribute('src', event.target.result);
            }

            setNomeArquivo(file[0].name);
            fileReader.readAsDataURL(file[0]);
        } else {
            setOpenUpload(false);
        }
    }
    const addAnexo = () => {
        setOpenUpload(true);
        let file = document.getElementById("file");
        file.click();
    }
    function handleSalvarAnexo(e) {
        if (!tipoAnexo || tipoAnexo.length < 2) {
            setErroTipo('Indique o tipo para filtrar do upload');
            return;
        }
        const dado = {
            nome: nomeArquivo,
            tipo: tipoAnexo,
            descricao: descricaoAnexo
        }
        console.log(dado);
        Service.POST("/api/security/salvaAnexo", dado).then(r => {
            console.log(r);
            uploadArquivo(r)
        }).catch(e => {
            console.log("erro--->", e)
            alert(e);
        })
    }
    function createImg(src) {
        console.log("createImg--->", src)
        // const img = document.createElement('img');
        // img.src = src
        // img.addEventListener('click', function (e) {
        //     console.log( ">>click<<")
        //     if (onSelect) onSelect(e.currentTarget);
        // });
        // clonedContent.replaceWith(img);

        
        console.log('>>>handleTabelaEscala<<');
        const remove = document.createElement('p');
        remove.setAttribute("id", "paraRemover");
        remove.textContent = "---";
        clonedContent.replaceWith(remove);
        const htmlOld = refDiv.current.innerHTML;
        let html = '';
        const el = document.getElementById("very2Editor");
        if (!el) {
            html = refDiv.current.innerHTML;
        } else {
            html = el.innerHTML;
        }

        const dado = {
            code: html,
            imagem: src
        }
        Service.POST("/api/security/model/imagem", dado).then(r => {
            console.log(r);
            if (r.success) {
                refDiv.current.innerHTML = r.dado;
                handleClose();
                refreshEditor();                        
            } else {
                // alert(r.msg);
                setMsg(r.msg);
                setOpenSnack(true);
                refDiv.current.innerHTML = htmlOld;
            }
        })
    }
    function uploadArquivo(ret) {
        let input = document.getElementById("file");
        const file = input.files;
        let dados = new FormData();
        dados.append('file', file[0]);

        Service.UPLOAD("/api/security/anexar/" + ret.id, dados).then(r => {
            const resp = JSON.parse(r)
            if (resp.success) {
                // const img = document.createElement('img');
                // img.src = "/api/getAnexoById/" + r.anexo.idArquivo;
                // img.addEventListener('click', function (e) {
                //     if (onSelect) onSelect(e.currentTarget);
                // });

                // clonedContent.replaceWith(img);
                
                createImg("/api/getAnexoById/" + resp.anexo.idArquivo)
                setOpenUpload(false);
                setIsShowGaleria(false);
                handleClose();
            } 
            else {
                alert(resp.msg)
            }

        }).catch(e => {
            console.log("erro--->", e)
            alert(e);
        })
    }
    function criaFromGaleria(img) {
        console.log(img);
        createImg("/api/getAnexoById/" + img.id)
        setOpenUpload(false);
        setIsShowGaleria(false);
        handleClose();
    }
    function showGaleria() {
        if (!isShowGaleria) return;
        return (
            <GaleriaComp onAction={criaFromGaleria} onClose={() =>{
                handleClose();
            }}/>
        )
    }
    function showUpload() {
        if (!openUpload) return;
        return (
            <List dense>
                <Stack direction="row" spacing={2} sx={{ border: '2px solid blue', p: 2 }}>
                    <Stack spacing={2} sx={{ m: 1 }}>
                        <TextField label="Nome" variant="outlined" value={nomeArquivo} onChange={(e) => setNomeArquivo(e.target.value)} />
                        <TextField autoFocus
                            placeholder='Tipifique para faciliar futuras pesquisas'
                            label="Tipo" variant="outlined" value={tipoAnexo} onChange={(e) => { setTipoAnexo(e.target.value); setErroTipo(''); }}
                            error={erroTipo.length > 1}
                            helperText={erroTipo}
                        />
                        <TextField label="Descrição" variant="outlined" multiline rows={4} value={descricaoAnexo} onChange={(e) => setDescricaoAnexo(e.target.value)} />

                        <ButtonGroup variant="text" aria-label="Basic button group">
                            <Button onClick={() => setOpenUpload(false)}
                                startIcon={<NavigateBefore />}
                            >
                                Voltar
                            </Button>
                            <Button onClick={handleSalvarAnexo}>Salvar</Button>
                        </ButtonGroup>


                    </Stack>
                    <img style={{ objectFit: "contain" }}
                        src="/enptyFile.png" alt="Imagem a ser enviada" id="file-preview" width="250" height="300"
                        onClick={addAnexo}
                    />
                </Stack>
            </List>
        )
    }
    function showLinkImg() {
        if (!linkImg) return;
        return (
            <List dense>
                <ListItem disablePadding alignItems="flex-start" >
                    <Tooltip title="Voltar">
                        <IconButton color='primary' onClick={() => setLinkImg(false)}>
                            <NavigateBefore />
                        </IconButton>
                    </Tooltip>

                    <TextField label='informe e link da imagem' size='small' id='link-imagem' />
                    <Tooltip title="Submeter link">
                        <IconButton color='primary' onClick={handleSubmetLink}>
                            <Check />
                        </IconButton>
                    </Tooltip>
                </ListItem>

            </List>
        )
    }
    function showMainChoise() {
        if (linkImg) return;
        if (openUpload) return;
        if (isShowGaleria) return;
        return (
            <List dense>
                <ListItem disablePadding alignItems="flex-start" >
                    <ListItemButton onClick={addAnexo}>
                        <UploadFile />
                        <ListItemText primary="Upload do computador" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding alignItems="flex-start" >
                    <ListItemButton onClick={() => setLinkImg(true)}>
                        <Link />
                        <ListItemText primary="Link" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding alignItems="flex-start" >
                    <ListItemButton onClick={() => setIsShowGaleria(true)}>
                        <Collections />
                        <ListItemText primary="Galeria" />
                    </ListItemButton>
                </ListItem>
            </List>
        )
    }

    return (
        <React.Fragment>
            <Tooltip title="Imagem">
                <IB
                    color={image ? 'primary' : 'secundary'}
                    onClick={handleClick}
                    size="small"
                >
                    <Image />
                </IB>
            </Tooltip>
            {image &&
                <React.Fragment>
                    <Tooltip title="Colocar borda">
                        <IB
                            onClick={handleOpenBorda}
                            size="small"
                        >
                            <BorderOuter />
                        </IB>
                    </Tooltip>
                    
                    <ImagemSizeComp onSelect={onSelect} image={image} />

                </React.Fragment>
            }


            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {showLinkImg()}
                {showMainChoise()}
                {showUpload()}
                {showGaleria()}
            </Popover>
            <Menu
                id="menu-border"
                anchorEl={anchorElBorder}
                open={openBorder}
                onClose={handleCloseBorder}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                <Stack spacing={2} direction="row" sx={{ alignItems: 'center', m: 2 }}>
                    <Typography>1</Typography>
                    <Slider
                        sx={{ width: '80%' }}
                        defaultValue={70} aria-label="Volume" value={dashSize} onChange={handleChangeDashSize}
                        step={1}
                        marks
                        min={1}
                        max={10}
                    />
                    <Typography>10</Typography>
                </Stack>
                <ToggleButtonGroup
                    orientation="vertical"
                    value={borderStyle}
                    exclusive
                    onChange={handleChangeborderStyle}
                    sx={{ width: '100%' }}
                >
                    <ToggleButton value="solid" aria-label="solid">
                        Solido
                    </ToggleButton>
                    <ToggleButton value="dotted" aria-label="pontilhado">
                        Pontilhado
                    </ToggleButton>
                    <ToggleButton value="dashed" aria-label="dashed">
                        Traço
                    </ToggleButton>
                    <ToggleButton value="double" aria-label="double">
                        Duplo
                    </ToggleButton>
                </ToggleButtonGroup>
                <Stack direction="row" spacing={0}>
                    <Tooltip title="Borda completa">
                        <IB
                            onClick={() => handleBorda('all')}
                            size="small"
                        >
                            <BorderAll />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Borda fundo">
                        <IB
                            onClick={() => handleBorda('bottom')}
                            size="small"
                        >
                            <BorderBottom />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Borda esquerda">
                        <IB
                            onClick={() => handleBorda('left')}
                            size="small"
                        >
                            <BorderLeft />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Borda direita">
                        <IB
                            onClick={() => handleBorda('right')}
                            size="small"
                        >
                            <BorderRight />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Borda topo">
                        <IB
                            onClick={() => handleBorda('top')}
                            size="small"
                        >
                            <BorderTop />
                        </IB>
                    </Tooltip>
                    <Tooltip title="Limpar borda">
                        <IB
                            onClick={() => handleBorda('none')}
                            size="small"
                        >
                            <BorderClear />
                        </IB>
                    </Tooltip>
                </Stack>
            </Menu>
            <input type="file" id="file" style={{ display: 'none' }} onChange={upload} />
            {/* <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openSnackBar}
                autoHideDuration={5000}
                onClose={handleCloseSnackBar}
                message="Escolha um local para colocar o anexo"
            /> */}
<Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack}>
                <Alert
                    onClose={handleCloseSnack}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg}
                </Alert>
            </Snackbar>
        </React.Fragment>
    )
}